import type { ComponentProps } from 'react';

import createModalsContext from '~/domains/common/context/createModalsContext';

import type CollectEntryFeesInfoModal from './types/CollectEntryFeesInfoModal/CollectEntryFeesInfoModal';
import type RewardsProgramModal from './types/RewardsProgramModal/RewardsProgramModal';
import type SelfManageInfoModal from './types/SelfManageInfoModal/SelfManageInfoModal';
import type IntroModal from './types/IntroModal/IntroModal';
import type GenericModal from './types/GenericModal/GenericModal';
import type PricingInfoModal from './types/PricingInfoModal/PricingInfoModal';
import type GameplayDiscardModal from './types/GameplayDiscardModal/GameplayDiscardModal';
import type GameplayLearnHowModal from './types/GameplayLearnHowModal/GameplayLearnHowModal';

type CollectEntryFeesInfoModalType = {
  type: 'CollectEntryFeesInfoModal';
} & Omit<ComponentProps<typeof CollectEntryFeesInfoModal>, 'onClose' | 'isOpen'>;

type RewardsProgramModalType = {
  type: 'RewardsProgramModal';
} & Omit<ComponentProps<typeof RewardsProgramModal>, 'onClose' | 'isOpen'>;

type SelfManageInfoModalType = {
  type: 'SelfManageInfoModal';
} & Omit<ComponentProps<typeof SelfManageInfoModal>, 'onClose' | 'isOpen'>;

type IntroModalType = {
  type: 'IntroModal';
} & Omit<ComponentProps<typeof IntroModal>, 'onClose' | 'isOpen'>;

type GenericModalType = {
  type: 'GenericModal';
} & Omit<ComponentProps<typeof GenericModal>, 'onClose' | 'isOpen'>;

type PricingInfoModalType = {
  type: 'PricingInfoModal';
} & Omit<ComponentProps<typeof PricingInfoModal>, 'onClose' | 'isOpen'>;

type GameplayDiscardModalType = {
  type: 'GameplayDiscardModal';
} & Omit<ComponentProps<typeof GameplayDiscardModal>, 'onClose' | 'isOpen'>;

type GameplayLearnHowModalType = {
  type: 'GameplayLearnHowModal';
} & Omit<ComponentProps<typeof GameplayLearnHowModal>, 'onClose' | 'isOpen'>;

type ModalType =
  | CollectEntryFeesInfoModalType
  | RewardsProgramModalType
  | SelfManageInfoModalType
  | IntroModalType
  | GenericModalType
  | PricingInfoModalType
  | GameplayDiscardModalType
  | GameplayLearnHowModalType;

const { ModalsContext, ModalsContextProvider } = createModalsContext<ModalType>();

export {
  ModalsContext as ContestManageModalsContext,
  ModalsContextProvider as ContestManageModalsContextProvider,
};

export type { ModalType as ContestManageModalType };
